import React, { useContext } from "react"
import { Link } from "gatsby"
import styled, { css } from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Highlight } from "react-instantsearch-dom"
import { GlobalStateContext } from "@context/GlobalContextProvider"

// Utils
import {
  CategoryColorLightFinder,
  CategoryTitleString,
} from "@utils/knowledge-center"

const size = {
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const ArticleWrapper = styled(Link)`
  min-width: 300px;
  position: relative;
  transition: 0.3s ease-in-out;

  :hover {
    text-decoration: none;
  }
  .list-image {
    min-height: 232px;
    max-height: 232px;
    border-radius: 2px 2px 0 0;
    color: transparent;

    ${below.tablet`
     min-height: 264px;
     max-height: 264px;
    `}
    ${below.mobile`
     min-height: 164px;
     max-height: 164px;
    `}
  }
`
const TitleCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  background-color: white;
  margin: 0;
  border-radius: 0 0 2px 2px;

  .category {
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 900;
    font-size: 12px;
    line-height: 15px;
    color: #2d3748;
    text-decoration: none;
    padding: 6.5px 8px;
    letter-spacing: 0.1em;
    margin-bottom: 16px;
    background: ${props => props.categoryColor};
  }

  .reading-time {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: var(--grey);
    margin-bottom: 0;
    letter-spacing: 0.2px;
  }

  .title {
    margin-bottom: 8px;

    span {
      font-weight: 600;
      font-size: 22px;
      line-height: 28px;
      color: var(--alt-black);
      min-height: 64px;
      letter-spacing: 0.01em;
    }
  }

  mark {
    color: white;
    background-color: var(--pacific-blue);
  }
  svg {
    margin-left: 12px;
    stroke: black;
    width: 16px;
    transition: 0.3s ease-in-out;
  }

  .body-excerpt {
    margin-bottom: 16px;

    font-size: 16px;
    line-height: 20px;

    span {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 0;
      text-align: left;
      text-decoration: none;
      color: #2d3748;
    }
  }
`

const ListCard = props => {
  const hit = props.hit.hit
  const hasImage = hit.featureImage || hit.featuredImage

  const slug = props.bankerData
    ? `/${props.bankerData?.slug}/knowledge-center/${hit.slug}/`
    : `/knowledge-center/${hit.slug}/`

  return (
    <ArticleWrapper to={`${slug}`}>
      {hasImage && (
        <GatsbyImage
          image={
            hit.featureImage
              ? hit.featureImage.gatsbyImageData
              : hit.featuredImage.gatsbyImageData
          }
          alt={hit.title}
          // placeholderStyle={{ filter: "blur(8px)" }}
          className="list-image"
        />
      )}
      <TitleCard categoryColor={CategoryColorLightFinder(hit.category)}>
        <h3 className="category">{CategoryTitleString(hit.category)}</h3>

        <div className="title">
          {hit.cardTitle ? (
            <Highlight hit={hit} attribute="cardTitle" tagName="mark" />
          ) : (
            <Highlight hit={hit} attribute="shortenedTitle" tagName="mark" />
          )}
        </div>
        <div className="body-excerpt">
          {hit.shortDescription ? (
            <Highlight hit={hit} attribute="shortDescription" tagName="mark" />
          ) : (
            <Highlight hit={hit} attribute="shortenedBodyText" tagName="mark" />
          )}
        </div>
        <p className="reading-time">{`${hit.timeToRead} minute read`}</p>
      </TitleCard>
    </ArticleWrapper>
  )
}

export default ListCard
